import React, { ReactNode, useEffect } from 'react';
import styled from 'styled-components';

import { Skeleton } from '@/ui/Skeleton';
import { makeNamespacedComponent } from '@/ui/utils';
import { Button } from '@/ui/Button';
import { slugify } from '@/utils/misc';
import { JourneySectionCard } from '@/features/journey/admin/atoms/JourneySectionCard';
import { ROUTE_PATH } from '@/constants/routePaths';

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 0 0 0;
`;

const ActionsStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

const ContentStyled = styled.div`
  padding: 32px;
  background-color: ${({ theme }) => theme.tones.neutral[99]};
  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.colors.neutral.outline1};
`;

const SectionCardContainer = styled.div`
  padding: 0 0 24px 0;
`;

type JourneyViewSectionListCardProps = {
  section: { title: string; description: string; totalEffort?: number; childrenCount?: number };
  journey: { id: number; title: string };
  children: ReactNode;
};

const JourneyViewSectionListCard = ({ journey, section, children }: JourneyViewSectionListCardProps): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <RootStyled>
      <ActionsStyled>
        <Button
          to={`${ROUTE_PATH.JOURNEY_BASE}/${journey.id}/${slugify(journey.title)}`}
          state={{ noScroll: true }}
          variant="ghost"
          icon={['fas', 'arrow-left']}
          $iconPosition="start"
          size="large"
        >
          All items
        </Button>
      </ActionsStyled>
      <ContentStyled>
        <SectionCardContainer>
          <JourneySectionCard {...section} />
        </SectionCardContainer>
        {children}
      </ContentStyled>
    </RootStyled>
  );
};

const LoadingState = () => <Skeleton height={560} />;

const _JourneyViewSectionListCard = makeNamespacedComponent(JourneyViewSectionListCard, {
  LoadingState,
});

export { _JourneyViewSectionListCard as JourneyViewSectionListCard };
